function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "6ale92us7a",
  d: "M0 0h21v24H0z"
}), /*#__PURE__*/React.createElement("path", {
  id: "8xv111bekc",
  d: "M0 0h21v24H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(9 2.503 31.807)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "u3rmq1910b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#6ale92us7a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M14.028 9.23C9.09 13.382 4.676 17.312 3.441 24c4.8-3.35 11.15-4.144 14.514-8.194C21.427 11.628 20.81 5.85 21 0c-4.04 1.92-8.042 2.983-12.137 3.924-7.836 1.8-11.151 10.328-7.177 18.254C6.09 14.216 9.284 10.75 14.03 9.231z",
  fill: "#0E4816",
  mask: "url(#u3rmq1910b)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 1.495)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "3l15sqp3nd",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#8xv111bekc"
})), /*#__PURE__*/React.createElement("path", {
  d: "M14.028 9.23C9.09 13.382 4.676 17.312 3.441 24c4.8-3.35 11.15-4.144 14.514-8.194C21.427 11.628 20.81 5.85 21 0c-4.04 1.92-8.042 2.983-12.137 3.924-7.836 1.8-11.151 10.328-7.177 18.254C6.09 14.216 9.284 10.75 14.03 9.231z",
  fill: "#589D62",
  mask: "url(#3l15sqp3nd)"
})));

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 26,
  height: 27,
  viewBox: "0 0 26 27",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _ref, _ref2);

export default __webpack_public_path__ + "static/media/leaf-icon-green.ae37262e.svg";
export { SvgComponent as ReactComponent };